<script setup>
import FormView from '@/views/FormView.vue'
import { loadLanguageAsync } from '@/plugins/i18n'
import {onMounted} from '@vue/runtime-core'
import {useGlobalStore} from '@/store'

const globalStore = useGlobalStore()

onMounted(() =>
{
  loadLanguageAsync()
  globalStore.initRewards()
})
</script>

<template>
  <FormView :active-step="globalStore.activeStep" />
</template>

